<template>
    <el-drawer title="审核" @close="closeDialogDW"  direction="ltr" size="48%"  :visible.sync="dialogVisible">
      <el-form :inline="true" ref="addFrom" enctype="multipart/form-data" :model="addFrom" :rules="rules"   class="demo-form-inline inpBox jiaoyan" label-width="100px" size="mini">
          <div style="margin-top:14px">
            <el-form-item label="运单编号:"  >
              <div class="jieguo">{{addFrom.wayNo}}</div>
            </el-form-item>
            <el-form-item label="所属订单:"  >
              <div class="jieguo">{{addFrom.orderNo}}</div>
            </el-form-item>
          </div>
          <hr>
          <div class="addressBox">
          <div class="box1">
                <div class="item" style="margin-bottom: 20px;">
                  <div class="box1T" style="color:#0e6eec"><i class="el-icon-location"></i>(发){{addFrom.deliverCompany}}<i class="el-icon-edit"  @click="addxzdzFn(2)"></i></div>
                  <div class="box1B"><span>{{addFrom.deliverPerson}}</span><span>{{addFrom.deliverPhone}}</span>
                  <span>{{addFrom.deliverAddress}}（{{addFrom.deliverLongitude}}，{{addFrom.deliverLatitude}}）</span></div>
                </div>
                <div class="item" style="margin-bottom: 20px;">
                  <div class="box1T" style="color:#F56C6C" > <i class="el-icon-location"></i>(收){{addFrom.receivingCompany}}<i class="el-icon-edit"  @click="addxzdzFn(1)"></i></div>
                  <div class="box1B"><span>{{addFrom.receivingPerson}}</span><span>{{addFrom.receivingPhone}}</span>
                  <span>{{addFrom.receivingAddress}}（{{addFrom.receivingLongitude}}，{{addFrom.receivingLatitude}}）</span></div>
                </div>
            </div>
          </div>
          <div>
          <el-form-item label="调度量:"  >
            <div class="jieguo">{{addFrom.weight}}{{addFrom.unitMeasurement}}</div>
          </el-form-item>
          <el-form-item label="计价方式:">
              <div class="jieguo">{{['单价','包干'][addFrom.valuationType-1]}}</div>
          </el-form-item>
           <el-form-item prop="" label="单价:">
            <div  class="jieguo" v-if="addFrom.valuationType==1">{{addFrom.publishTonPrice}}元/{{addFrom.unitMeasurement}}</div>
            <div  class="jieguo" v-if="addFrom.valuationType==2">-</div>
          </el-form-item>
           <el-form-item prop="fatePrice" label="承运运费:">
            <div  class="jieguo">{{addFrom.fatePrice}}元</div>
          </el-form-item>
          </div>
           <div>
          <el-form-item label="接单时间:" prop="receivingTime"  >
                <el-date-picker
                  v-model="addFrom.receivingTime"
                  type="datetime"
                  value-format="timestamp"
                  default-time="18:00:00"
                    placeholder="选择日期时间"
                    @change="RchangeDateFn"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="装车时间:" prop="outTime"  >
                <el-date-picker
                  v-model="addFrom.outTime"
                  type="datetime"
                  value-format="timestamp"
                  default-time="18:00:00"
                    placeholder="选择日期时间"
                    @change="OchangeDateFn"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="到货时间:" prop="arrivalTime"  >
                <el-date-picker
                  v-model="addFrom.arrivalTime"
                  type="datetime"
                  value-format="timestamp"
                  default-time="18:00:00"
                    placeholder="选择日期时间"
                    @change="AchangeDateFn"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="货物类型:" class="jiage" prop="productType">
              <el-select  v-model="addFrom.productType"  value-key="productId"  placeholder="请选择">
                <el-option v-for="item in productTypes" :label="item.name" :value="item" :key="item.productId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item >
            <el-button type="primary"     @click="guijiFn">更新轨迹</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="承运司机:" prop="dirverName">
            <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="addFrom.dirverName"></el-input>
          </el-form-item>
          <el-form-item label="身份证号:" prop="dirverIdentityNo">
            <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="addFrom.dirverIdentityNo"></el-input>
          </el-form-item>
          <el-form-item label="车牌号:" prop="vhcNo">
            <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="addFrom.vhcNo"></el-input>
          </el-form-item>
         <el-form-item >
            <el-button type="primary"     @click="zhipaiFn">指派</el-button>
          </el-form-item>
        </div>
        <hr>
         <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>收款人信息</span>
            </h4>
          </div>
          <div>
             <el-form-item label="收款方类型:" prop="commissionPlatform" class="ziti" >
              <template >
                <el-radio-group v-model="addFrom.waybillMode"  @change="waybillModeChange">
                  <el-radio :label="1" >司机</el-radio>
                  <el-radio :label="2">车队长</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
             <el-form-item label="收款方姓名:" prop="dirverName" v-if="addFrom.waybillMode==1">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="addFrom.dirverName"></el-input>
             </el-form-item>
             <el-form-item label="收款方姓名:" prop="captainName" v-if="addFrom.waybillMode==2">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="addFrom.captainName"></el-input>
             </el-form-item>
          </div>
          <hr>
        <div v-if="imgList.loadingImgs.length>0">
        <h4 class="title">
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>装车凭证</span>
            <el-button type="text"  style="margin-left: 10px;" v-if="imgList.loadingImgs.length!=4"   @click="pingzhengFn(1)">上传凭证</el-button>
          </h4>
          <div style="display: flex; flex-wrap: wrap;" v-if="imgList.loadingImgs.length>0">
           <div class="imgBox" v-for="(item,index) in imgList.loadingImgs" :key="index" style="position: relative;"  >
                <el-image
                  :src="item.fileUrlOSS"
                  style="width: 330px; height: 200px"
                  :preview-src-list="getSrcList(index,loadingImgs)">
                </el-image>
                <!-- <p v-if="item.imageType" style="text-align: center;">图片类型:{{['单据','现场图'][item.imageType-1]}}</p> -->
                <el-form-item label="图片类型:" :prop="'type'+item.id"  >
                <template >
                  <el-radio-group v-model="imgform['type'+item.id]" >
                    <el-radio :label="1" >单据</el-radio>
                    <el-radio :label="2">现场图</el-radio>
                    <el-radio :label="3">人车合照</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
              <div style="position: absolute;  font-size: 30px;right: 25px;top: 10px;color: #000;" @click="delFn(item.id)"><i class="el-icon-delete"></i></div>
            </div>
          </div>
          <div style="padding-left:16px;margin-bottom:20px"><span style="margin: 10px 50px 10px 12px;">上传人：{{imgList.loadingImgs[0].createUserName}}</span><span>上传时间：{{imgList.loadingImgs[0].createTime|dateFormat}} </span></div>
        </div>
         <div class="addressBox" v-if="imgList.unloadImgs.length>0">
          <h4 class="title">
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>卸车凭证</span>
            <el-button type="text"  style="margin-left: 10px;" v-if="imgList.unloadImgs.length!=4"   @click="pingzhengFn(2)">上传凭证</el-button>
          </h4>
          <div style="display: flex; flex-wrap: wrap;">
           <div class="imgBox"  v-for="(item,index) in imgList.unloadImgs" :key="index" style="position: relative;">
                <el-image
                :src="item.fileUrlOSS"
                  style="width: 330px; height: 200px"
                  :preview-src-list="getSrcList(index,unloadImgs)">
                </el-image>
                 <!-- <p v-if="item.imageType" style="text-align: center;">图片类型:{{['单据','现场图'][item.imageType-1]}}</p> -->
                <el-form-item label="图片类型:" :prop="'type'+item.id" >
                <template >
                  <el-radio-group v-model="imgform['type'+item.id]" >
                    <el-radio :label="1" >单据</el-radio>
                    <el-radio :label="2">现场图</el-radio>
                    <el-radio :label="3">人车合照</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
               <div style="position: absolute;  font-size: 30px;right: 25px;top: 10px;color: #000;" @click="delFn(item.id)"><i class="el-icon-delete"></i></div>
            </div>
            </div>
          <div style="padding-left:16px;margin-bottom:20px"><span style="margin: 10px 50px 10px 12px;">上传人：{{imgList.unloadImgs[0].createUserName}}</span><span>上传时间：{{imgList.unloadImgs[0].createTime|dateFormat}} </span></div>
        </div>
        <hr>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审核意见</span>
          </h4>
        </div>
         <el-checkbox-group v-model="checkList" style="margin:20px" @change="SHYJchange">
          <el-checkbox label="装卸货照片重复上传"  ></el-checkbox>
          <el-checkbox label="装卸货照片未体现车牌号"></el-checkbox>
          <el-checkbox label="出入库单据不清晰" ></el-checkbox>
          <el-checkbox label="装卸货照片缺失"></el-checkbox>
          <el-checkbox label="其他" ></el-checkbox>
        </el-checkbox-group>
        <div style="text-align: center;margin-bottom:20px" v-if="qita">
            <el-input type="textarea" style="width: 95%;" v-model="addFrom.qita" maxlength="100" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
        </div>
        <p style="color:red;padding-left:20px;font-size:14px">注：如果地址、时间、轨迹问题，平台人员处理后审核通过即可。</p>
      </el-form>
       <div class="footerBox">
        <el-button type="primary" @click="SHsaveFn(1)">通过</el-button>
        <el-button type="primary" @click="SHsaveFn(2)">驳回</el-button>
      </div>
      <el-drawer title="历史轨迹" size="100%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible.sync="dialogVisible">
          <maphistorySH :map-data="addFrom" v-if="dialogVisible" ref="maphistorySH"></maphistorySH>
      </el-drawer>
       <!-- 选择司机 -->
   <el-dialog title="选择司机" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body  :visible.sync="dialogAdd" @close="closeDialog" width="900px" center>
        <div ref="searchBox" >
        <el-form :inline="true" :model="deiverFrom"  class="demo-form-inline" label-width="86px" size="mini">
        <div class="searchBox inpBox" >
            <div>
              <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder=""   type="text" v-model="deiverFrom.name" ></el-input>
              </el-form-item>
              <!-- <el-form-item label="联系电话:" prop="dirverMobile">
                <el-input  placeholder="" v-model="deiverFrom.dirverMobile"></el-input>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="SJsearchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm()">重置</el-button>
              </el-form-item>
            </div>
        </div>
       </el-form>
       </div>
       <div style="height:500px">
        <el-table :data="sijiList"  ref="xzdz" height="100%" v-loading="loading1"     highlight-current-row  border >
          <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text"  @click="SJZPfn(scope.row)" size="mini">指派</el-button>
            </template>
          </el-table-column>
        <el-table-column prop="name" width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
        <el-table-column prop="mobile" width="180" label="联系电话"></el-table-column>
        <el-table-column prop="identityNo" min-width="260" :show-overflow-tooltip="true" label="身份证号"></el-table-column>
      </el-table>
      </div>
       <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="derverChange"
        @current-change="derverCurrentChange"
        :current-page="deiverFrom.pageNo"
        :page-sizes="[25,50,100,200,1000]"
        :page-size="deiverFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="SJtotal">
      </el-pagination>
    </div>
        <el-dialog append-to-body title="选择车辆" :visible.sync="carMark"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="carList" ref="table" v-loading="loading1" bordersize="mini"
                  class="table" height="380px" style="width: 100%"   center  border   >
                <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                  </template>
                </el-table-column>
               <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
                <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
                <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
                <el-table-column prop="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="carMark=false">关闭</el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog title="上传凭证" center :visible.sync="uploadDialog"   append-to-body  @close="closeDialog" width="400px" top="20px" >
      <el-form :inline="true" :model="uploadFrom" ref="uploadFrom" :rules="rules" class="demo-form-inline jiaoyan" style="display: flex;flex-direction: column;"
       label-width="86px" size="mini">
          <el-form-item label="图片类型:" prop="imageType"  >
            <template >
              <el-radio-group v-model="uploadFrom.imageType" >
                <el-radio :label="1" >单据</el-radio>
                <el-radio :label="2">现场图</el-radio>
                <el-radio :label="3">人车合照</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item  prop="img"  style="text-align: center;">
           <uploadImg :img='uploadFrom.img' key="0" @remove ='handleRemove' v-if="uploadDialog"  @change ='imgPreview'></uploadImg>
          </el-form-item>

       </el-form>
     <div slot="footer" class="dialog-footer">
       <el-button @click="uploadDialog = false" size="mini">取 消</el-button>
       <el-button type="primary" @click="IMGsave()" size="mini">确 定</el-button>
     </div>
   </el-dialog>
    <!-- 选择地址 -->
    <selectAddress :type= "addressType" :tenantId="addFrom.tenantId" v-if="dialogXzdz"  @handleCurrentChange="handleCurrentChange" @destroy="destroy"></selectAddress>
  </el-drawer>

</template>

<script>
import { assignDriverList, getCVehicleInfoListByDriverId } from '@/api/vgs-driver2.0'
import { findRelByvhIdAndDriId } from '@/api/vgs-match'
import selectAddress from '@/components/networkFreight/selectAddress.vue'
import maphistorySH from '@/components/maphistorySH.vue'
import { dropDownList } from '@/api/soc-stock'
import { wayListImgs, sWayFileDel, insertWayListFile, getWayByWayNo, auditRecordsWay, updateWayTrajectory } from '@/api/soc-customer'
import uploadImg from '@/components/uploadImg.vue'
import { compressImage } from '@/utils/compressImage'
export default {
  components: {
    selectAddress,
    maphistorySH,
    uploadImg
  },
  name: 'lookVoucher',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialogVisible: true,
      addFrom: { productType: {} },
      dialogXzdz: false, // 选择地址
      deiverFrom: {// 指派司机
        pageNo: 1,
        pageSize: 50
      },
      sijiList: [],
      SJtotal: 0,
      carMark: false,
      loading1: false,
      dialogAdd: false,
      carList: [],
      productTypes: [],
      imgList: {// 凭证
        loadingImgs: [],
        unloadImgs: []
      },
      loadingImgs: [],
      unloadImgs: [],
      imgform: {},
      uploadDialog: false,
      uploadFrom: { img: [], imageType: 1 },
      checkList: [],
      qita: false,
      rules: {
        dirverName: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        receivingTime: [
          { required: true, message: '请选择接单时间', trigger: 'blur' }
        ],
        outTime: [
          { required: true, message: '请选择装车时间', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择卸车时间', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        imageType: [
          { required: true, message: '请选择图片类型', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    dropDownList().then(res => {
      this.productTypes = res
    })
    this.addFrom = this.rowData
    getWayByWayNo({ businessNo: this.rowData.wayNo }).then(res => {
      this.addFrom = res
      this.$set(this.addFrom, 'productType', { productId: res.productTypeId, name: res.productTypeName })
    })
    this.getPingZheng()
  },
  methods: {
    // 切换支付对象
    waybillModeChange () {
      if (this.addFrom.waybillMode == 1) {
        this.addFrom.captainId = ''
        this.addFrom.captainName = ''
        this.addFrom.captainIdNum = ''
      } else {
        findRelByvhIdAndDriId({
          driverId: this.addFrom.dirverId,
          vhcId: this.addFrom.vhcId
        }).then(res => {
          this.addFrom.captainId = res.userId
          this.addFrom.captainName = res.userName
          this.addFrom.captainIdNum = res.userIdentityNo
          console.log(this.addFrom)
        }).catch(error => {
          this.$alert(error.message, '系统提示')
          // this.$message({
          //   showClose: true,
          //   message: error.message,
          //   type: 'error',
          //   duration: 0,
          //   onClose () {
          //   }
          // })
        })
      }
    },
    SHYJchange () {
      let arr = [].concat(this.checkList)
      let n = this.checkList.indexOf('其他')
      if (n == -1) {
        this.qita = false
        this.addFrom.auditOpinion = arr.toString()
      } else {
        this.qita = true
        arr.splice(n, 1)
        this.addFrom.auditOpinion = arr.toString()
      }
    },
    SHsaveFn (n) { // 审核状态：0：待审核；1：审核通过，2：审核驳回，3：不审核
      if (n == 2) {
        if (this.checkList.length > 0) {
          if ((this.qita && this.addFrom.qita) || this.qita == false) {
            if (this.addFrom.qita && this.qita) {
              if (this.addFrom.auditOpinion) {
                this.addFrom.auditOpinion = this.addFrom.auditOpinion + ',' + this.addFrom.qita
              } else {
                this.addFrom.auditOpinion = this.addFrom.qita
              }
            }
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            auditRecordsWay({
              auditOpinion: this.addFrom.auditOpinion,
              id: this.addFrom.id,
              auditStatus: '2'
            }).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.drawerFlag = false
              this.$emit('destroy')
              this.$emit('successFn')
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            this.$alert('请输入驳回原因', '系统提示')
          }
        } else {
          this.$alert('请选择驳回原因', '系统提示')
        }
      } else {
        this.$refs.addFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.addFrom.auditStatus = 1
            let arr = []
            for (var key in this.imgform) {
              let json = { id: key.substring(4), imageType: this.imgform[key] }
              arr.push(json)
            }
            this.addFrom.imgs = arr
            if (this.addFrom.productType) {
              this.addFrom.productTypeId = this.addFrom.productType.productId
              this.addFrom.productTypeName = this.addFrom.productType.name
              this.addFrom.productTypeCode = this.addFrom.productType.productTypeCode
            }
            auditRecordsWay(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.drawerFlag = false
              this.$emit('destroy')
              this.$emit('successFn')
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    // 更新轨迹
    guijiFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      updateWayTrajectory({ wayId: this.addFrom.id }).then(res => {
        loading.close()
        this.$refs.maphistorySH.searchFn()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 上传凭证
    pingzhengFn (n) {
      this.uploadDialog = true
      this.uploadFrom.flag = n
      this.uploadFrom.wayId = this.rowData.id
    },
    IMGsave () {
      this.$refs.uploadFrom.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          let that = this
          compressImage(this.uploadFrom.img.url, this.uploadFrom.img.raw, {
            width: 1000
          }).then(result => {
            delete that.uploadFrom['img']
            imgfile.append('file', result)// result即为压缩后的结果
            // imgfile.append('flag', that.uploadFrom.flag)
            // imgfile.append('imageType', that.uploadFrom.type)
            // imgfile.append('wayId', that.rowData.id)
            imgfile.append('params', JSON.stringify(that.uploadFrom))
            const loading = that.$loading({
              lock: true,
              text: '正在处理...'
            })
            insertWayListFile(imgfile).then(res => {
              loading.close()
              this.getPingZheng()
              this.uploadDialog = false
            }).catch(error => {
              that.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          })
        } else {
          return false
        }
      })
    },
    // 图片上传
    handleRemove (data) {
      this.$set(this.uploadFrom, 'img', '')
    },
    imgPreview (data) {
      this.$set(this.uploadFrom, 'img', data[0])
    },
    delFn (id) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sWayFileDel({ id: id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getPingZheng()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 获取凭证
    getPingZheng () {
      this.loadingImgs = []
      this.unloadImgs = []
      wayListImgs({ wayId: this.rowData.id }).then(res => {
        this.imgList = res
        res.loadingImgs.forEach(item => {
          this.loadingImgs.push(item.fileUrlOSS)
          this.$set(this.imgform, 'type' + item.id, item.imageType)
        })
        res.unloadImgs.forEach(item => {
          this.unloadImgs.push(item.fileUrlOSS)
          this.$set(this.imgform, 'type' + item.id, item.imageType)
        })
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    RchangeDateFn () {
      if (this.addFrom.outTime) {
        if (this.addFrom.outTime < this.addFrom.receivingTime) {
          this.$alert('接单时间不能大于装车时间', '系统提示')
          this.$set(this.addFrom, 'receivingTime', this.rowData.receivingTime)
        }
      }
    },
    OchangeDateFn () {
      if (this.addFrom.outTime < this.addFrom.receivingTime) {
        this.$alert('装车时间不能小于接单时间', '系统提示')
        this.$set(this.addFrom, 'outTime', this.rowData.outTime)
        return
      }
      if (this.addFrom.arrivalTime) {
        if (this.addFrom.arrivalTime - this.addFrom.outTime < 1000 * 60 * 20) {
          this.$alert('卸车与装车之间不得小于20分钟', '系统提示')
          this.$set(this.addFrom, 'outTime', this.rowData.outTime)
        }
      }
    },
    AchangeDateFn () {
      if (this.addFrom.arrivalTime - this.addFrom.outTime < 1000 * 60 * 20) {
        this.$alert('卸车与装车之间不得小于20分钟', '系统提示')
        this.$set(this.addFrom, 'arrivalTime', this.rowData.arrivalTime)
      }
    },
    // 组件销毁
    destroy () {
      this.dialogXzdz = false
      this.dialogAdd = false
    },
    // 选择地址
    addxzdzFn (n) {
      this.addressType = n
      this.dialogXzdz = true
    },
    handleCurrentChange (val) {
      this.dialogXzdz = false
      if (this.addressType == 1) {
        this.$set(this.addFrom, 'receivingCompany', val.company)
        this.$set(this.addFrom, 'receivingPerson', val.person)
        this.$set(this.addFrom, 'receivingPhone', val.phone)
        this.$set(this.addFrom, 'receivingAddress', val.name)
        this.addFrom.receivingProvinceCode = val.provinceCode
        this.addFrom.receivingCityCode = val.cityCode
        this.addFrom.receivingAreaCode = val.areaCode
        this.addFrom.receivingProvinceName = val.provinceName
        this.addFrom.receivingCityName = val.cityName
        this.addFrom.receivingAreaName = val.areaName
        this.addFrom.receivingAddressId = val.id
        this.addFrom.receivingLongitude = val.longitude
        this.addFrom.receivingLatitude = val.latitude
      } else {
        this.$set(this.addFrom, 'deliverCompany', val.company)
        this.$set(this.addFrom, 'deliverPerson', val.person)
        this.$set(this.addFrom, 'deliverPhone', val.phone)
        this.$set(this.addFrom, 'deliverAddress', val.name)
        this.addFrom.deliverProvinceCode = val.provinceCode
        this.addFrom.deliverCityCode = val.cityCode
        this.addFrom.deliverAreaCode = val.areaCode
        this.addFrom.deliverProvinceName = val.provinceName
        this.addFrom.deliverCityName = val.cityName
        this.addFrom.deliverAreaName = val.areaName
        this.addFrom.deliverAddressId = val.id
        this.addFrom.deliverLongitude = val.longitude
        this.addFrom.deliverLatitude = val.latitude
      }
      this.$refs.addFrom.clearValidate()
    },
    // 指派
    zhipaiFn () {
      this.dialogAdd = true
      this.getDerverList()
    },
    // 司机指派
    SJZPfn (row) {
      this.addFrom.dirverId = row.id
      this.addFrom.dirverIdentityNo = row.identityNo
      this.addFrom.dirverName = row.name
      this.addFrom.dirverMobile = row.mobile
      getCVehicleInfoListByDriverId({ driverId: row.id }).then(res => {
        if (res.length == 0) {
          this.$alert('该司机下暂无审核通过的车辆', '系统提示')
        } else if (res.length == 1) {
          this.carOk(res[0])
        } else {
          this.carMark = true
          this.carList = res
        }
      })
    },
    carOk (row) {
      this.$set(this.addFrom, 'vhcId', row.id)
      this.$set(this.addFrom, 'vhcNo', row.vhcNo)
      this.$set(this.addFrom, 'vhcNoColor', row.noColourCode)
      this.$set(this.addFrom, 'businessLicenseNo', row.businessLicenseNo)
      this.dialogAdd = false
      this.carMark = false
      console.log(this.addFrom)
    },
    SJsearchFn () {
      this.getDerverList()
    },
    getDerverList () {
      this.loading1 = true
      assignDriverList(this.deiverFrom).then(res => {
        this.loading1 = false
        this.sijiList = res.list
        this.SJtotal = res.total
      })
    },
    derverChange (val) {
      this.deiverFrom.pageSize = val
      this.getDerverList()
    },
    derverCurrentChange (val) {
      this.deiverFrom.pageNo = val
      this.getDerverList()
    },
    closeDialog () {
      this.deiverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.uploadFrom = { img: [], imageType: 1 }
    },
    closeDialogDW () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.jieguo{
  width: 180px;
}
.box1{
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  .item{
    max-width: 48%;
    margin-left: 10px;
    font-size: 14px;
  }
  .box1T{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .box1B{
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right: 20px;
      line-height: 26px;
    }
  }
  .el-icon-edit{
    color: #0e6eec;
    font-size: 18px;
    margin-right: 4px;
  }
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin-left: 28px;
}

.imgBox{
  display: flex;
  flex-direction: column;
}
/deep/.el-image-viewer__wrapper{
  z-index: 99999!important;
}
.box1 .item{
  width: 100%;
  max-width: 100%;
}
</style>
